module.exports = __webpack_public_path__ + "img/48.a1e44650.png";